import FormatCurrency from 'components/Common/FormatCurrency'
import LineGuidedtoursIcon from 'LuxKit/Icons/line/LineGuidedtoursIcon'
import TextLink from 'LuxKit/TextLink'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import useTailorMadeTour from 'hooks/TourV2/useTailorMadeTour'
import React from 'react'
import { useIntl } from 'react-intl'
import AdditionalWaysToExperienceMessagingTile from './AdditionalWaysToExperienceMessagingTile'
import { getTailorMadeTourRequestFormUrl } from 'lib/tours/tailorMadeTourUtils'

interface Props {
  tourOffer: App.Tours.TourV2Offer
  tourOfferVariation: App.Tours.TourV2OfferVariation
}

function TailorMadeTourMessagingTile({ tourOffer, tourOfferVariation }: Props) {
  const intl = useIntl()
  const tailorMadeTour = useTailorMadeTour()
  return <AdditionalWaysToExperienceMessagingTile
    heading={intl.formatMessage({
      id: 'toGjpBuOdB',
      defaultMessage: 'Tailor-Made Tour',
      description: 'Heading for tailor-made tour messaging tile',
    })}
    description={<>
      {/* TODO: i18n - contains leading/trailing spaces */}
      Start crafting a personalised itinerary with our Tours Concierge for a fully refundable{' '}
      {!!tailorMadeTour?.data && <FormatCurrency value={tailorMadeTour.data.fee} />}
      {!tailorMadeTour?.data && <TextLoadingBox width="4ch" />}
      {/* TODO: i18n - contains leading/trailing spaces */}
      {' '}deposit.
    </>}
    Icon={LineGuidedtoursIcon}
    action={<TextLink size="small" disabled={!tailorMadeTour?.data} to={getTailorMadeTourRequestFormUrl({ tourOffer, tourOfferVariation })}>{intl.formatMessage({
      id: '0RZPD34vRg',
      defaultMessage: 'Submit a request',
      description: 'Link text to submit a tailor-made tour request',
    })}
    </TextLink>}
  />
}

export default TailorMadeTourMessagingTile
